// extracted by mini-css-extract-plugin
export default {"container":"style_container__6zR+t","box":"style_box__6QrhP"};